import { IntegrationsAgreggatedSyncableStateValuesEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

export type CompensationsFilters = {
  legalEntityIds?: number[]
  teamIds?: number[]
  workplaceIds?: number[]
  validationTypes?: string[]
  integrationsAgreggatedSyncableStates?: string[]
}

export const syncStatusFilterConfig = () => {
  const options: Record<IntegrationsAgreggatedSyncableStateValuesEnum, string> = {
    synced: i18n.t('integrations.filters.sync_status.synced'),
    partially_synced: i18n.t('integrations.filters.sync_status.partially_synced'),
    outdated: i18n.t('integrations.filters.sync_status.outdated'),
    failed: i18n.t('integrations.filters.sync_status.failed'),
    pending: i18n.t('integrations.filters.sync_status.pending'),
  }

  return {
    integrationsAgreggatedSyncableStates: {
      label: i18n.t('integrations.filters.sync_status.sync_status_label'),
      type: 'in' as const,
      options: {
        options: Object.entries(options).map(([value, label]) => ({
          label,
          value,
        })),
      },
    },
  }
}
